import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import {
  UrlShortenerProvider,
  useUrlShortenerContext,
} from 'pages/settings/pages/urlShortener/context/UrlShortenerContext'
import { UrlShortenerList } from 'pages/settings/pages/urlShortener/ui/UrlShortenerList/UrlShortenerList'
import { UrlShortenerEmpty } from 'pages/settings/pages/urlShortener/ui/UrlShortenerEmpty/UrlShortenerEmpty'

const UrlShortener = observer(() => {
  const { init, isEmpty, initialLoading } = useUrlShortenerContext()

  useEffect(() => {
    void init()
  }, [])

  if (initialLoading) return <SpinnerLoader ariaLabel={'UrlShortenerPage'} />
  if (isEmpty) return <UrlShortenerEmpty />

  return <UrlShortenerList />
})

export const UrlShortenerPage = observer(() => (
  <FullPageWrapper>
    <UrlShortenerProvider>
      <UrlShortener />
    </UrlShortenerProvider>
  </FullPageWrapper>
))
